import { STYLE_NONE, ToggleButton } from '@eventbrite/eds-button';
import { GenericLazyString } from '@eventbrite/i18n';
import React, { FunctionComponent } from 'react';
import { LinkText } from './LinkText';

export interface ToggleExpansionLinkProps {
    /**
     * Content to be displayed on the link
     */
    text: GenericLazyString | string | null;
    /**
     * Content to be used as the link's alt text
     */
    altText: GenericLazyString | string | null;
    /**
     * Trailing text added to the toggle as info message
     */
    trailingText: GenericLazyString | string | null;
    /**
     * If expansion is expanded
     */
    isExpanded: boolean;
    /**
     * Callback when the link gets clicked
     */
    onToggle?: (isPressed: boolean) => void;
}

export const ToggleExpansionLink: FunctionComponent<
    ToggleExpansionLinkProps
> = ({ text, trailingText, isExpanded, altText, onToggle }) => {
    const toggleChildren = <LinkText text={text} isExpanded={isExpanded} />;
    const trailingTextNode = trailingText ? (
        <p className="eds-align--right eds-text-color--grey-600">
            {trailingText}
        </p>
    ) : null;

    const toggleChildrenAlt = (
        <LinkText text={altText || text} isExpanded={isExpanded} />
    );

    return (
        <div className="toggle-expansion-link eds-align--space-between">
            <ToggleButton
                childrenAlt={toggleChildrenAlt}
                onPress={onToggle}
                style={STYLE_NONE}
                isPressed={isExpanded}
            >
                {toggleChildren}
            </ToggleButton>
            {trailingTextNode}
        </div>
    );
};

export default ToggleExpansionLink;
